import styles from './BasketStyle.module.scss'
import { useBasketInformation } from '../Order/model/useBasketInfomation'
import { useCartDrawer } from 'context/BasketDriverContext/BasketDriverContext'
import { useWishlistDrawer } from 'context/WishlistDrawerContext/WishlistDrawerContext'
import MainBasketInformations from './ui/Informations/BasketInformations'
import { CloseIcon, ShoppingCartIcon } from 'shared/assets'
import { WishListIcon } from 'assets'
import { NavLink } from 'react-router-dom'
import { ERoutePaths } from 'libraries/router/types'
import { ProductSlider } from 'components'
import { useGetFavoriteMerchantQuery } from '../Favorites/api/apiFavoritesSlice'
import { useContext } from 'react'
import { SupplierContext } from 'context/SupplierContext'

export const CartDrawer = () => {
  const {
    handleOpenOrderModal,
    basketList,
    basketListLoading,
    productList,
    loading,
    popularPorducts,
    is_supplier,
    renderBasketCartInformation,
  }: any = useBasketInformation()

  const { isOpen, closeDrawer } = useCartDrawer()
  const { openDrawer: openWishlistDrawer } = useWishlistDrawer()
  const { is_supplier: isSupplier } = useContext(SupplierContext)

  const handleOpenWishlist = () => {
    closeDrawer()
    openWishlistDrawer()
  }

  const queryParam = isSupplier ? Number(window.config.CUSTOMER_ID) : 0

  // Get favorites for count
  const { data: favoritesProducts } = useGetFavoriteMerchantQuery({
    merchant_id: queryParam,
    page: 1,
  })

  const isLoadingProducts = is_supplier ? false : loading
  const bestSellersProducts = is_supplier ? popularPorducts?.data : productList

  // @ts-ignore
  // @ts-ignore
  return (
    <>
      <div className={`${styles.drawer} ${isOpen ? styles.open : ''}`}>
        {basketList?.data?.length === 0 ? (
          <>
            <div className={styles.header}>
              <CloseIcon onClick={closeDrawer} className={styles.header__closeIcon} />
              <div className={styles.header__icons}>
                <div className={styles.header__icons__wishlist} onClick={handleOpenWishlist}>
                  <div className={styles.header__iconWrapper}>
                    <WishListIcon />
                    {(favoritesProducts?.meta?.total ?? 0) > 0 && (
                      <span className={styles.header__count}>{favoritesProducts?.meta.total}</span>
                    )}
                  </div>
                </div>
                <div className={styles.header__iconWrapper}>
                  <div style={{marginTop:8}} className={styles.header__iconWrapper__cart}>
                  <ShoppingCartIcon />
                  </div>
                  {(basketList?.summary?.total_count ?? 0) > 0 && (
                    <span className={styles.header__count}>{basketList.summary.total_count}</span>
                  )}
                </div>
              </div>
            </div>
            <div className={styles.content}>
              <h1 className={styles.content__title}>КОШИК</h1>
              <div className={styles.emptyState}>
                <div className={styles.emptyState__icon}>
                  <svg width="24" height="24" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M0 0.9C0 0.402944 0.402944 0 0.9 0H2.96611C3.7499 0 4.46277 0.453923 4.79434 1.16413L5.29661 2.24H19.0359C20.5596 2.24 21.5335 3.8643 20.8155 5.20831L18.1207 10.253C17.7698 10.9098 17.0857 11.32 16.341 11.32H8.55539L7.4965 12.6466C7.38272 12.7891 7.48422 13 7.6666 13H19.2333C19.7304 13 20.1333 13.4029 20.1333 13.9C20.1333 14.3971 19.7304 14.8 19.2333 14.8H7.6666C5.97582 14.8 5.03493 12.8451 6.08971 11.5237L7.07055 10.2949L3.90802 3.52072L3.16332 1.92558C3.12756 1.84897 3.05066 1.8 2.96611 1.8H0.9C0.402944 1.8 0 1.39706 0 0.9ZM8.6953 9.52H16.341C16.4214 9.52 16.4952 9.47575 16.533 9.4049L19.2278 4.3602C19.3053 4.21522 19.2002 4.04 19.0359 4.04H6.13695L8.6953 9.52ZM7.9 17.4C7.9 18.5046 7.00457 19.4 5.9 19.4C4.79543 19.4 3.9 18.5046 3.9 17.4C3.9 16.2954 4.79543 15.4 5.9 15.4C7.00457 15.4 7.9 16.2954 7.9 17.4ZM17.9 19.4C19.0046 19.4 19.9 18.5046 19.9 17.4C19.9 16.2954 19.0046 15.4 17.9 15.4C16.7954 15.4 15.9 16.2954 15.9 17.4C15.9 18.5046 16.7954 19.4 17.9 19.4Z" fill="#6D6D6D"/>
                  </svg>
                </div>
                <p className={styles.emptyState__text}>КОШИК ПОРОЖНІЙ</p>
              </div>
              <ProductSlider
                productList={bestSellersProducts}
                is_bestsellers={true}
                loading={isLoadingProducts}
              />
            </div>
          </>
        ) : (
          <>
            <div className={styles.header}>
              <CloseIcon onClick={closeDrawer} className={styles.header__closeIcon} />
              <div className={styles.header__icons}>
                <div className={styles.header__icons__wishlist} onClick={handleOpenWishlist}>
                  <div className={styles.header__iconWrapper}>
                    <WishListIcon />
                    {favoritesProducts?.meta?.total && favoritesProducts.meta.total > 0 && (
                      <span className={styles.header__count}>{favoritesProducts.meta.total}</span>
                    )}
                  </div>
                </div>
                <div className={styles.header__iconWrapper}>
                  <div style={{marginTop:2, maxHeight:22}} >
                  <ShoppingCartIcon />
                  </div>
                  {basketList?.summary?.total_count && basketList.summary.total_count > 0 && (
                    <span className={styles.header__count}>{basketList.summary.total_count}</span>
                  )}
                </div>
              </div>
            </div>
            <div className={styles.content}>
              <h1 className={styles.content__title}>КОШИК ({basketList?.summary?.total_count || 0})</h1>

              <MainBasketInformations
                closeDrawer={closeDrawer}
                basketListLoading={basketListLoading}
                is_supplier={is_supplier}
                popularPorducts={popularPorducts}
                productList={productList}
                basketList={basketList}
                loading={loading}
                handleOpenOrderModal={handleOpenOrderModal}
                renderBasketCartInformation={renderBasketCartInformation}
              />
            </div>
            <div className={styles.footer}>
              <div className={styles.footer__total}>
                <p className={styles.footer__title}>
                  Сума товарів {is_supplier ? basketList?.summary?.total_formatted : basketList?.summary?.total_formatted}
                </p>
              </div>
              <div className={styles.footer__buttons}>
                <NavLink to={ERoutePaths.Basket} className={styles.footer__btnLink}>
                  <button
                    className={styles.footer__btnPrimary}
                    disabled={loading || basketList?.summary?.total_count === 0 || renderBasketCartInformation?.count === 0}
                    onClick={closeDrawer}
                  >
                    ОФОРМИТИ ЗАМОВЛЕННЯ
                  </button>
                </NavLink>
                <NavLink to={ERoutePaths.Cart} className={styles.footer__btnLink}>
                  <button
                    className={styles.footer__btnSecondary}
                    disabled={loading || basketList?.summary?.total_count === 0 || renderBasketCartInformation?.count === 0}
                    onClick={closeDrawer}
                  >
                    ПЕРЕЙТИ ДО КОШИКА
                  </button>
                </NavLink>
              </div>
            </div>
          </>
        )}
      </div>

      {isOpen && <div className={styles.overlay} onClick={closeDrawer} />}
    </>
  )
}
